<template>
	<div class="form">
		<div class="delete" v-if="canDelete" @click="confirm"></div>

		<b-form-row>
			<b-col cols="12" md="7">
				<input-component
					name="fullName"
					label="Nome completo/Razão social"
					:required="true"
					v-model="fullName"
					maxlength="255" />
			</b-col>

			<b-col cols="6" md="5">
				<input-component
					name="nationality"
					label="Nacionalidade"
					:required="true"
					v-model="nationality"
					maxlength="100" />
			</b-col>

			<b-col cols="6" md="4">
				<input-component
					name="postalCode"
					label="CEP"
					maxlength="255"
					:required="true"
					:check="true"
					v-model="postalCode"
					:mask="this.country === 'Brasil' ? '#####-###' : 'XXXXXXXXXXXXXXXXXXXX'"
					@input="getAddress" />
			</b-col>

			<b-col cols="12" md="8">
				<input-component
					name="street"
					label="Endereço"
					:required="true"
					ref="street"
					v-model="street"
					maxlength="255" />
			</b-col>
		</b-form-row>

		<b-form-row>
			<b-col cols="6" md="4">
				<input-component
					name="number"
					label="Número"
					class="mb-0"
					maxlength="6"
					:required="true"
					v-model="number" />
			</b-col>

			<b-col cols="6" md="4">
				<input-component
					name="complement"
					label="Complemento"
					class="mb-0"
					v-model="complement"
					maxlength="150" />
			</b-col>

			<b-col cols="12" md="4">
				<input-component
					name="percent"
					class="mb-0"
					:required="true"
					maxlength="4"
					label="% Propriedade"
					v-model="percent" />
			</b-col>
		</b-form-row>

		<b-form-row>
			<b-col cols="12" md="4">
				<input-component
					name="city"
					label="Cidade"
					:required="true"
					ref="city"
					v-model="city"
					maxlength="255" />
			</b-col>

			<b-col cols="12" md="4">
				<input-component
					name="state"
					label="Estado"
					:required="true"
					ref="state"
					v-model="state"
					maxlength="255" />
			</b-col>

			<b-col cols="12" md="4">
				<select-component
					name="country"
					label="País"
					:required="true"
					:options="countries"
					ref="country"
					v-model="country" />
			</b-col>

			<files-component
				ref="cpf"
				:fileType="'cpf'"
				:files="[]"
				:required="true"
				:showIndex="false"
				:uploadedFiles="$store.state.form.uploadedDocuments.cpf"
				:modal-id="'modal-confirm-document'"
				:loopIndex="formKey"
				label="Cópia do RG, CPF, RNE ou passaporte de todos os administradores, sócios com 25% ou mais de participação na empresa e dos representantes que assinam o contrato"
				sub-label="caso o sócio seja uma pessoa jurídica, cópia do Contrato Social e cópia do RG, RNE ou passaporte e CPF de todos os sócios com mais de 25% de participação no sócio pessoa jurídica." />

			<files-component
				ref="addressPartners"
				:fileType="'address_partners'"
				:files="[]"
				:required="true"
				:showIndex="false"
				:uploadedFiles="$store.state.form.uploadedDocuments.addressPartners"
				:modal-id="'modal-confirm-document'"
				:loopIndex="formKey"
				label="Cópia de documento que ateste o endereço das pessoas físicas constantes no contrato social da empresa (sócios e administradores)"
				sub-label="conta de serviço público ou atestado de entidade competente: conta de água, luz, telefone, etc." />

			<confirm-modal-component type="document" modal-id="modal-confirm-document" />
			<confirm-modal-component type="contact" modal-id="modal-confirm-contact" />
		</b-form-row>
	</div>
</template>

<script>
import axios from "axios";

import { minLength, numeric, required } from "vuelidate/lib/validators";
import countries from "@/static/countries";

import InputComponent from "@/components/Form/Inputs/InputComponent";
import SelectComponent from "@/components/Form/Inputs/SelectComponent";
import FilesComponent from "@/components/Form/Inputs/FilesComponent";
import ConfirmModalComponent from "@/components/Form/ConfirmModalComponent";

export default {
	name: "OwnerFormComponent",
	components: { InputComponent, SelectComponent, FilesComponent, ConfirmModalComponent },
	props: { formKey: Number, canDelete: Boolean, salesforceContactId: String },
	async mounted() {
		if (this.$store.state.form.ownersAndContacts.owner[this.formKey].fullName) {
			this.$v.$touch();
		}

		if (this.$store.state.form.ownersAndContacts.owner[this.formKey].postalCode) {
			await this.getAddress();
		}

		this.$refs.country.value = "Brasil";
	},
	computed: {
		fullName: {
			get() {
				return this.$store.state.form.ownersAndContacts.owner[this.formKey].fullName;
			},
			set(value) {
				this.$store.commit("setContactData", {
					form: "owner",
					key: "fullName",
					index: this.formKey,
					value,
				});
			},
		},
		nationality: {
			get() {
				return this.$store.state.form.ownersAndContacts.owner[this.formKey].nationality;
			},
			set(value) {
				this.$store.commit("setContactData", {
					form: "owner",
					key: "nationality",
					index: this.formKey,
					value,
				});
			},
		},
		postalCode: {
			get() {
				return this.$store.state.form.ownersAndContacts.owner[this.formKey].postalCode;
			},
			set(value) {
				this.$store.commit("setContactData", {
					form: "owner",
					key: "postalCode",
					index: this.formKey,
					value,
				});
			},
		},
		street: {
			get() {
				return this.$store.state.form.ownersAndContacts.owner[this.formKey].street;
			},
			set(value) {
				this.$store.commit("setContactData", {
					form: "owner",
					key: "street",
					index: this.formKey,
					value,
				});
			},
		},
		number: {
			get() {
				return this.$store.state.form.ownersAndContacts.owner[this.formKey].number;
			},
			set(value) {
				this.$store.commit("setContactData", {
					form: "owner",
					key: "number",
					index: this.formKey,
					value,
				});
			},
		},
		complement: {
			get() {
				return this.$store.state.form.ownersAndContacts.owner[this.formKey].complement;
			},
			set(value) {
				this.$store.commit("setContactData", {
					form: "owner",
					key: "complement",
					index: this.formKey,
					value,
				});
			},
		},
		city: {
			get() {
				return this.$store.state.form.ownersAndContacts.owner[this.formKey].city;
			},
			set(value) {
				this.$store.commit("setContactData", {
					form: "owner",
					key: "city",
					index: this.formKey,
					value,
				});
			},
		},
		state: {
			get() {
				return this.$store.state.form.ownersAndContacts.owner[this.formKey].state;
			},
			set(value) {
				this.$store.commit("setContactData", {
					form: "owner",
					key: "state",
					index: this.formKey,
					value,
				});
			},
		},
		percent: {
			get() {
				return this.$store.state.form.ownersAndContacts.owner[this.formKey].percent;
			},
			set(value) {
				const cleaned = value.replace(/\D/g, "");

				let numericValue = parseInt(cleaned, 10);

				if (isNaN(numericValue)) numericValue = "";
				if (numericValue > 100) numericValue = 100;

				const formatted = numericValue !== "" ? `${numericValue}%` : "";

				this.$store.commit("setContactData", {
					form: "owner",
					key: "percent",
					index: this.formKey,
					value: formatted,
				});
			},
		},
		country: {
			get() {
				return this.$store.state.form.ownersAndContacts.owner[this.formKey].country;
			},
			set(value) {
				this.$store.commit("setContactData", {
					form: "owner",
					key: "country",
					index: this.formKey,
					value,
				});
			},
		},
		countries: () => countries,
		cpfFileCount() {
			const owner = this.$store.state.form.ownersAndContacts.owner[this.formKey];
			const documentOrder = owner?.documentOrder || [];
			const pendingDeletes = this.$store.state.form.pendingDeletes?.cpf || [];
			const pendingFiles = this.$store.state.form.pendingFiles?.cpf || [];
			const fromDocumentOrder = documentOrder
				.filter(
					(doc) => doc.form === "cpf" && (doc.ownerIndex === this.formKey || doc.ownerIndex === undefined),
				)
				.filter((doc) => !this.isDocPendingDelete(doc, pendingDeletes));
			const fromPending = pendingFiles.filter((pendingFile) => pendingFile.loopIndex === this.formKey);
			return fromDocumentOrder.length + fromPending.length;
		},
		addressPartnersFileCount() {
			const owner = this.$store.state.form.ownersAndContacts.owner[this.formKey];
			const documentOrder = owner?.documentOrder || [];
			const pendingDeletes = this.$store.state.form.pendingDeletes?.addressPartners || [];
			const pendingFiles = this.$store.state.form.pendingFiles?.addressPartners || [];
			const fromDocumentOrder = documentOrder
				.filter(
					(doc) =>
						doc.form === "address_partners" &&
						(doc.ownerIndex === this.formKey || doc.ownerIndex === undefined),
				)
				.filter((doc) => !this.isDocPendingDelete(doc, pendingDeletes));
			const fromPending = pendingFiles.filter((pendingFile) => pendingFile.loopIndex === this.formKey);
			return fromDocumentOrder.length + fromPending.length;
		},
		cpfFiles() {
			return this.cpfFileCount;
		},
		addressPartnersFiles() {
			return this.addressPartnersFileCount;
		},
	},
	methods: {
		/**
		 * Verifica se o documento está em pendingDeletes (marcado para exclusão), por id ou por nome + loopIndex.
		 */
		isDocPendingDelete(doc, pendingDeletes) {
			if (!pendingDeletes || !pendingDeletes.length) return false;
			const docId = doc.salesforceFileId || doc.id;
			const docName = doc.name || doc.filename;
			return pendingDeletes.some((pendingDelete) => {
				const loopMatch = pendingDelete.loopIndex === this.formKey || pendingDelete.loopIndex == null;
				if (!loopMatch) {
					return false;
				}

				const deleteId = pendingDelete.salesforceFileId || pendingDelete.file?.salesforceFileId || pendingDelete.file?.id;
				if (docId && deleteId && docId === deleteId) {
					return true;
				}
				
				const deleteName = pendingDelete.name || pendingDelete.file?.name || pendingDelete.file?.filename;
				if (docName && deleteName && docName === deleteName) {
					return true;
				}
				return false;
			});
		},
		confirm() {
			this.$store.commit("setConfirmForm", {
				form: "owner",
				key: this.formKey,
				salesforceContactId: this.salesforceContactId,
				formKey: this.formKey,
			});

			this.$bvModal.show("modal-confirm-contact");
		},
		async getAddress() {
			if (this.country !== "Brasil" || this.postalCode.length !== 9) {
				return;
			}

			const regex = /^\d{5}-\d{3}$/;

			if (!regex.test(this.postalCode)) {
				this.validCep = false;
				return;
			}

			const cep = this.postalCode.replace(/\D/g, "");

			if (cep.length !== 8) {
				return;
			}

			let res = await axios.get(`https://viacep.com.br/ws/${cep}/json/`).catch((err) => console.log(err));

			this.validCep = true;

			const addressData = res.data;

			if (!addressData.erro) {
				this.$refs.street.setValue(addressData.logradouro);
				this.$refs.city.setValue(addressData.localidade);
				this.$refs.state.setValue(addressData.uf);
			}
		},
	},
	validations: {
		fullName: {
			required,
		},
		nationality: {
			required,
		},
		postalCode: {
			required,
			validCEP(value) {
				return this.country === "Brasil" ? value.length === 9 && /^\d{5}-\d{3}$/.test(value) : true;
			},
		},
		street: {
			required,
		},
		number: {
			required,
			numeric,
		},
		percent: {
			required,
			minLength: minLength(2),
			minValue(value) {
				return value.replace("%", "") >= 25;
			},
		},
		city: {
			required,
		},
		state: {
			required,
		},
		country: {
			required,
		},
		complement: {},
		cpfFiles: {
			atLeastOne(value) {
				return value >= 1;
			},
		},
		addressPartnersFiles: {
			atLeastOne(value) {
				return value >= 1;
			},
		},
	},
};
</script>

<style lang="scss">
.form {
	border-radius: 8px;
	border: 2px solid #e7e7e7;
	padding: 40px 40px 15px 40px;
	margin: 20px 0;
	position: relative;
}

.delete {
	content: " ";
	top: -10px;
	right: -10px;
	width: 25px;
	z-index: 99;
	height: 25px;
	position: absolute;
	border-radius: 50%;
	background-color: #ed5417;
	cursor: pointer;
}

.delete::after {
	content: "−";
	color: white;
	position: absolute;
	font-weight: bold;
	margin-left: 0.45rem;
	margin-top: 0.1rem;
}
</style>
